import { Draggable } from 'react-beautiful-dnd';
import { DeleteOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';

const Course = ({ course, index, removeCourse, openAddModal, rsSkillsGroup, columnId }) => {
  const isDragDisabled = course.id === 'task-1';
  const priorityColor = course.hasOwnProperty('priority') ? (course.priority === 1 ? 'priority-high' : course.priority === 2 ? 'priority-medium' : '') : '';

  return (
    <Draggable draggableId={course.id} index={index} isDragDisabled={isDragDisabled}>
      {(provided, snapshot) => {
        const containerClass = classNames('card-container', {
          dragging: snapshot.isDragging,
          disabled: snapshot.isDropDisabled,
        });

        return (
          <div className={containerClass} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <div className="card">
              <div className="rightBtn">
                <Tooltip title={isNaN(columnId.charAt(0)) ? 'Permanently remove' : 'Move back to the course list'} placement="top">
                  <span
                    onClick={() =>
                      removeCourse({
                        id: course.id,
                        type: course.type,
                        semester: course.semester,
                        position: columnId,
                      })
                    }
                  >
                    {isNaN(columnId.charAt(0)) ? <DeleteOutlined /> : <CloseOutlined />}
                  </span>
                </Tooltip>
              </div>

              <div className="leftBtn">
                <Tooltip title="Edit" placement="top">
                  <span onClick={() => openAddModal(course.id)}>
                    <EditOutlined />
                  </span>
                </Tooltip>
              </div>

              <div className="type">
                {course.semester} {course.type} course
              </div>
              <Tooltip title={course.priority === 1 ? 'High Priority Course' : ''} placement="top"> 
                <div className={'title ' + priorityColor}>{course.name}</div>  
              </Tooltip>
              
              <div className="area_topics">
                <table>
                  <tbody>
                    {course.skills_group.map((sgId, idx) => {
                      const skill = rsSkillsGroup.find((e) => e.id === sgId) || {};
                      return (
                        <tr key={idx}>
                          <td>•&nbsp;</td>
                          <td>{skill.name || sgId}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default Course;
